import type { OrderView } from '@khaddi/contracts';
import { Button, Icon, Text, colors, radii } from '@khaddi/ui';
import { View } from 'react-native';

const stepLabel = (order: OrderView): string => {
  if (order.status === 'delivering') return 'Đang giao đến khách';
  if (order.status === 'new' || order.status === 'brewing') return 'Quán đang pha · chờ lấy hàng';
  return 'Đến quán lấy hàng';
};

export const ActiveOrderBanner = ({ order, onOpen }: { order: OrderView; onOpen: () => void }) => (
  <View
    style={{
      marginTop: -50,
      marginHorizontal: 16,
      backgroundColor: colors.surface,
      borderRadius: radii.xl,
      padding: 16,
      gap: 14,
      borderWidth: 2,
      borderColor: colors.primaryText,
      boxShadow: '0 8px 24px rgba(28, 69, 95,.14)',
    }}
  >
    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <View style={{ backgroundColor: colors.primary, borderRadius: radii.pill, paddingHorizontal: 10, paddingVertical: 4 }}>
        <Text variant="label" color={colors.onPrimary} style={{ fontSize: 12, fontWeight: '700' }}>
          Đơn đang giao · #{order.code}
        </Text>
      </View>
      <Text variant="caption">{order.cupCount} ly</Text>
    </View>
    <View style={{ flexDirection: 'row', gap: 12, alignItems: 'center' }}>
      <View style={{ width: 48, height: 48, borderRadius: 24, backgroundColor: colors.surfaceMuted, alignItems: 'center', justifyContent: 'center' }}>
        <Icon name="bike" size={24} color={colors.primaryText} strokeWidth={2.2} />
      </View>
      <View style={{ flex: 1, minWidth: 0 }}>
        <Text variant="heading">{stepLabel(order)}</Text>
        <Text variant="caption" numberOfLines={2}>
          {order.status === 'delivering' ? order.delivery?.address : order.branch.name}
        </Text>
      </View>
    </View>
    <Text variant="caption">Hoàn tất đơn này trước khi nhận đơn mới.</Text>
    <Button label="Mở đơn đang giao" icon="arrowRight" onPress={onOpen} />
  </View>
);
